import {BidderListDTO} from "./advertSummaryDTO";

